export default __webpack_public_path__ + "static/media/home-slide-img1.8aaede33.jpg";